import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Link} from 'react-router-dom';
import {Button} from 'primereact/button';
//////
import {Toast} from 'primereact/toast';

import { DATATABLE_CONFIG, ORG_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';

class OrganizationUnit extends Component {
    state = {
        selectedItems: []
    }
    
    actionTemplate = (rowData) => {
        return <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                <Link to={"/organization-unit/edit/"+rowData.orgId}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }

            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
                <Link to={"/organization-unit/view/"+rowData.orgId}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
            }
        </div>;
    }

    statusRender = (rowData) => {
        let status = <Button type="button" label="In Active" className="p-button-danger p-button-rounded" ></Button>
        if(rowData.isactive === true || rowData.isactive === null){
            status = <Button type="button" label="Active" className="p-button-success p-button-rounded" ></Button>
        }
        return <div className="actionCenter">
                    {status}
               </div>;
    }
    
    
    renderOrgNo = (rowData) => {
        let reportedTo = rowData.reportingToOrgid;
        let result = '';
        if(this.props.tableLists.orgUnitList !== undefined){
            result =  this.props.tableLists.orgUnitList.filter(list => {
                return list.orgId === reportedTo;
            }).reduce((_,el) => {
                return el.orgNo
            },'');
        }
        return result;
    }
  
    renderOrgName = (rowData) => {
        let reportedTo = rowData.reportingToOrgid;
        let result = '';
        if(this.props.tableLists.orgUnitList !== undefined){
            result =  this.props.tableLists.orgUnitList.filter(list => {
                return list.orgId === reportedTo;
            }).reduce((_,el) => {
                return el.name
            },'');
        }
        return result;
    }

    renderOrgType = (rowData) => {
        let orgType = rowData.orgType;
        let result = '';
        if(this.props.OrgType && this.props.OrgType.length > 0){
            result =  this.props.OrgType.filter(list => {
                return list.value === orgType;
            }).reduce((_,el) => {
                return el.label
            },'');
        }
        return result;
    }

    
 
    delete= () => {
        if(this.state.selectedItems.length > 0){
            const updatedValue = this.state.selectedItems.map( value => {
                return { DeleteID : value.orgId};
            })
            this.props.dynamicDeleteProcess('OrgUnit',updatedValue,'GetOrgUnit1');
        }
        else{
            this.growl.show({severity: 'error', summary: null, detail: 'Please select checkbox'});
        }
    }

    componentDidMount(){        
        this.props.getMasterKeywordList('OrgType'); 
        this.props.getMasterTableList('GetOrgUnit1');    
        this.getAccess = HASACCESS(ORG_SUBMENU_ID);
    }
  
    render() {   
        
        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        let tableData = [];

        if(this.props.tableLists.orgUnitList!==undefined) {
            tableData = this.props.tableLists.orgUnitList;
        }

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }

        return (
            <div className="p-grid padding">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Organization Unit</h1>
               
                        <div className="p-grid">

                            <div className="p-col-12 p-lg-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) &&
                                    <Link to="/organization-unit/add/new"><Button style={{float: 'right'}} label="Add Organization Unit" className="ml1"  icon="pi pi-plus"  /></Link>
                                }

                                {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                                 <Button  style={{float: 'right'}} onClick={this.delete} label="Delete" icon="pi pi-trash"  className="p-button-danger"/>
                                }
                                </div>                                
                            </div>
                    					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                            <DataTable value={tableData}  
                            selection={this.state.selectedItems} onSelectionChange={e => this.setState({selectedItems: e.value})}
                            globalFilter={this.state.globalFilter}  header={header} {...DATATABLE_CONFIG}>
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                <Column field="orgNo" header="Org Number" />
                                <Column field="name" header="Name" />
                                <Column field="reportingToOrgid" header="Reporting To Org Number" body={this.renderOrgNo} />
                                <Column field="reportingToOrgid" header="Reporting To Org Name" body={this.renderOrgName} />
                                <Column field="orgType" header="Unit Type" body={this.renderOrgType} />
                                <Column field="isactive" header="Status" body={this.statusRender} sortable={true} />
                                <Column field="action" body={this.actionTemplate} header="Action"/>
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists,
        OrgType : (state.keyword.OrgType!==undefined) ? state.keyword.OrgType : []
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(OrganizationUnit);